export default "__VITE_PUBLIC_ASSET__c42512a6__"